// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3yn_i","disabled":"FileBtn_disabled__kTyDo","warn":"FileBtn_warn__1ugA-","fade":"FileBtn_fade__1h2NJ"};